<template>
<div class="clamp-text">
  <div class="mb-2" :class="{ clamped }" ref="text">
    {{ value }}
  </div>
  <div class="btn btn-sm btn-link" v-if="btnVisible"
      @click="clamped = !clamped">
    {{ $t(`show_view.${clamped ? 'read_more' : 'less'}`) }}
  </div>
</div>
</template>

<script>
export default {
  props: {
    value: { type: String }
  },

  data () {
    return {
      clamped: true,
      btnVisible: false
    }
  },

  mounted () {
    this.calc()
    this.btnVisible = this.clamped
  },

  watch: {
    value (val) {
      this.calc()
      this.btnVisible = this.clamped
    }
  },

  methods: {
    calc () {
      const ele = this.$refs.text
      if (!ele) { return }
      this.clamped = ele.scrollHeight > ele.clientHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.clamp-text {
  .clamped {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
